module.exports = __webpack_public_path__ + "static/media/hot_zgmzs.d0b3779e.png";